export default __webpack_public_path__ + "static/media/Merriweather-Regular.db171654.woff2";